export default function readOnlyForm(display, currDiv) {
    if (currDiv == null) {
        currDiv = "innerContent";
    }

    var div = document.getElementById(currDiv);

    var inputs = Array.prototype.slice.call(div.getElementsByTagName("input"), 0);
    inputs = inputs.concat(Array.prototype.slice.call(div.getElementsByTagName("textarea"), 0));
    inputs = inputs.concat(Array.prototype.slice.call(div.getElementsByTagName("select"), 0));
    var buttons = Array.prototype.slice.call(div.getElementsByTagName("button"), 0);
    inputs = inputs.concat(buttons);
    var visible;
    if (display) {
        inputs.forEach(input => { input.removeAttribute("disabled"); });
        visible = "visible";
    } else {
        inputs.forEach(input => { if (!input.classList.contains("noDisabled")) { input.setAttribute("disabled", true); } });
        visible = "hidden";
    }
    buttons.forEach(button => { if (!button.classList.contains("noDisabled")) { button.style.visibility = visible; } });
}


// WEBPACK FOOTER //
// ./src/services/ReadOnlyForm.js